/* eslint-disable no-param-reassign */
export default (state, action) => {
  const { id, progress } = action.payload;
  const upload = state[id];
  if (upload) {
    upload.progress = Math.floor(((progress + upload?.uploadSize) / upload?.fileSize) * 100) || 0;
  }
};
